import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { html } from 'lit';

export type DownloadCardProps = {
  content?: Renderable;
  disabled?: boolean;
  onClick?: () => void;
};

export const DownloadCard = (props: DownloadCardProps) => {
  return html`
    <button
      type="button"
      class="card card-body flex-col text-left ${props.disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}"
      ?disabled=${Boolean(props.disabled)}
      @click=${() => {
        if (props.disabled) return;
        props.onClick?.();
      }}
    >
      <div class="flex flex-row gap-3">
        <div
          class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary transition-transform duration-200 ease-out group-hover:translate-y-1"
        >
          <span class="icon-[material-symbols--download-rounded] inline-block h-6 w-6"></span>
        </div>

        ${props.content}
      </div>
    </button>
  `;
};
